import React from 'react'
import { useTranslation } from 'react-i18next'

export default function PlaybookList({ templates = [], playbooks = [], maxActive = 3, canWrite = false, selectedType = null, onToggle, onSelect }) {
  const { t, i18n } = useTranslation()
  const english = i18n?.language?.startsWith('en') ?? false
  const activeTypes = new Set(playbooks.filter((playbook) => playbook.enabled !== false).map((playbook) => playbook.type))
  const activeCount = activeTypes.size

  return (
    <aside aria-label={t('playbook.listLabel')} className="flex w-full max-w-xs flex-col gap-3">
      <div className="font-mono text-[11px] tracking-[0.08em] text-slate-500">
        {t('playbook.activeCount', { count: activeCount, max: maxActive })}
      </div>
      <div className="flex flex-col gap-2">
        {templates.map((template) => {
          const checked = activeTypes.has(template.type)
          const unavailable = template.available === false
          const limitReached = !checked && activeCount >= maxActive
          const disabled = !canWrite || unavailable || limitReached
          const selected = selectedType === template.type
          return (
            <div
              key={template.type}
              className={`flex min-h-12 items-center justify-between rounded-lg border px-3 text-sm ${
                selected ? 'border-slate-900 bg-white font-semibold ring-2 ring-blue-100' : checked ? 'border-slate-300 bg-white font-semibold' : 'border-slate-200 bg-white'
              } ${unavailable ? 'bg-slate-100 text-slate-500' : ''}`}
            >
              <button type="button" aria-pressed={selected} onClick={() => onSelect?.(template.type)} className={`min-w-0 flex-1 truncate py-3 text-left ${unavailable ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                {(english ? template.label_en : template.label_vi) ?? template.label ?? template.type}
              </button>
              <span className="ml-2 flex shrink-0 items-center gap-2 whitespace-nowrap font-mono text-[11px] font-normal">
                {unavailable ? t('playbook.comingSoon') : checked ? t('playbook.enabled') : t('playbook.disabled')}
                <input
                  type="checkbox"
                  role="switch"
                  aria-label={(english ? template.label_en : template.label_vi) ?? template.label ?? template.type}
                  checked={checked}
                  disabled={disabled}
                  onChange={() => onToggle?.(template)}
                />
              </span>
            </div>
          )
        })}
      </div>
      {activeCount >= 2 && (
        <p className="text-xs leading-5 text-slate-500">{t('playbook.multiActiveHint')}</p>
      )}
      {templates.length === 0 && <p className="text-sm text-slate-500">{t('playbook.emptyTemplates')}</p>}
    </aside>
  )
}
